<!-- 平台管理 - 任务服务明细 -->
<template>
    <div>
        <div class="el-search-pager el-padding-no el-clearfix">
            <el-dropdown class="el-float-left" style="margin-bottom:10px;" size="small" trigger="click" placement="bottom-start" @command="exportTaskService">
                <el-button size="small" icon="fas fa-download" :loading="submiting" type="primary">
                    导出清单<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if='!isProducer' :command="2">导出清单(报价)</el-dropdown-item>
                    <el-dropdown-item :command="1">导出清单(成本)</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-pagination class="el-padding-no" background v-show="showTaskServiceQueryPager" @current-change="onTaskServiceQueryCurrentPageChange" :current-page.sync="taskServiceQueryForm.currentPage" :page-size="taskServiceQueryForm.pageSize" layout="prev, pager, next, total, slot" :total="taskServiceQueryTotal">
                <div class="el-pagination-pagesize">
                    <span class="first">每页显示</span>
                    <el-button-group>
                        <el-button :class="{active: taskServiceQueryForm.pageSize == 10}" @click="onTaskServiceQueryPageSizeChange(10);">10</el-button>
                        <el-button :class="{active: taskServiceQueryForm.pageSize == 20}" @click="onTaskServiceQueryPageSizeChange(20);">20</el-button>
                        <el-button :class="{active: taskServiceQueryForm.pageSize == 50}" @click="onTaskServiceQueryPageSizeChange(50);">50</el-button>
                        <el-button :class="{active: taskServiceQueryForm.pageSize == 100}" @click="onTaskServiceQueryPageSizeChange(100);">100</el-button>
                    </el-button-group>
                    <span class="last">条</span>
                </div>
            </el-pagination>
        </div>
        <div class="el-search-list">
            <el-table ref="taskServiceTable" v-loading="taskServiceQueryLoading" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: taskServiceQueryLoading}" :data="taskServiceList" :default-sort="taskServiceQuerySort" @sort-change="onTaskServiceQuerySortChange" style="width:100%;" :max-height="taskServiceTableHeight" class="el-table-overflow-x-hidden" empty-text="暂无数据">
                <el-table-column label="#" type="index" width="50"></el-table-column>
                <el-table-column label="服务对象" prop="serviceTargetName" width="150" align="center"></el-table-column>
                <el-table-column v-if="!isScyx" label="服务标的" prop="targetPlateNumber" width="120" align="center"></el-table-column>
                <el-table-column label="服务金额" prop="serviceAmounts" width="120" align="center">
                    <template slot-scope="scope">
                        <el-popover placement="top" trigger="hover">
                            <ul class="task-service-details">
                                <li v-for="(serviceDetail, index) in scope.row.taskServiceDetails" :key="index">
                                    <span class="name">{{serviceDetail.serviceName}}</span>：<span>{{serviceDetail.servicePrice}}{{serviceDetail.priceUnit}} x {{serviceDetail.serviceCount}}</span>
                                </li>
                            </ul>
                            <el-button type="text" slot="reference">{{scope.row.serviceAmounts}}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="服务机构" prop="taskConsumeOrgName" align="center"></el-table-column>
                <el-table-column label="团队长" prop="leaderStaffName" width="180" align="center">
                    <template slot-scope="scope">
                        <div>{{scope.row.leaderStaffName}}</div>
                        <div class="idcard">{{scope.row.leaderStaffIdcard}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="服务人员" prop="serviceStaffName" width="180" align="center">
                    <template slot-scope="scope">
                        <div>{{scope.row.serviceStaffName}}</div>
                        <div class="idcard">{{scope.row.serviceStaffIdcard}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="服务日期" prop="distributeDate" width="120" align="center"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort, parseFilename } from '@/utils.js';
import FileSaver from 'file-saver';
import { WINDOW_HEIGHT } from '@/constants.js';

export default {
    name: 'VispTaskService',
    props: ['taskId', 'serviceType', 'isProducer'],
    data() {
        return {
            submiting: false,
            taskServiceList: [],
            taskServiceQueryLoading: false,
            taskServiceQuering: false,
            taskServiceQueryForm: {
                taskId: '',
                fetchDetails: true,
                pageSize: 10,
                currentPage: 1
            },
            taskServiceQueryTotal: 0,
            taskServiceQuerySort: {
                prop: 'createTime',
                order: 'descending'
            }
        };
    },
    computed: {
        showTaskServiceQueryPager() {
            if (this.taskServiceQuering || this.taskServiceQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        taskServiceTableHeight() {
            return WINDOW_HEIGHT - 160;
        },
        isScyx() {
            return this.serviceType == 2;
        }
    },
    created() {},
    mounted() {},
    methods: {
        exportTaskService(exportType) {
            this.submiting = true;
            let url = PLATFORM_API.of(
                `/api/platform/visp/tasksummary/export/${this.taskServiceQueryForm.taskId}?exportType=${exportType}`
            );
            this.$http
                .post(
                    url,
                    {},
                    {
                        responseType: 'blob' // 设置响应数据类型
                    }
                )
                .then(response => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler)
                .then(() => {
                    this.submiting = false;
                });
        },
        queryTaskServiceList(loading) {
            this.taskServiceQueryForm.currentPage = 1;
            this.doQueryTaskServiceList(loading);
        },
        doQueryTaskServiceList(loading) {
            this.taskServiceQuering = true;
            if (loading) {
                this.taskServiceQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.taskServiceQueryForm,
                    mapSort(this.taskServiceQuerySort)
                );
                this.$http
                    .get(
                        PLATFORM_API.of('/api/platform/visp/taskservice/list'),
                        {
                            params: params
                        }
                    )
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.taskServiceList = result.data;
                            this.taskServiceQueryTotal = result.totalRowCount;
                        } else {
                            this.taskServiceList = [];
                            this.taskServiceQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.taskServiceList = [];
                        this.taskServiceQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.taskServiceQueryLoading = false;
                        }
                        this.taskServiceQuering = false;
                    });
            }, loading);
        },
        resetTaskServiceQueryForm() {
            this.$refs.taskServiceQueryForm.resetFields();
        },
        onTaskServiceQuerySortChange(parameter) {
            if (
                this.taskServiceQuerySort.prop != parameter.prop ||
                this.taskServiceQuerySort.order != parameter.order
            ) {
                this.taskServiceQuerySort.prop = parameter.prop;
                this.taskServiceQuerySort.order = parameter.order;
                this.queryTaskServiceList(1000);
            }
        },
        onTaskServiceQueryPageSizeChange(pageSize) {
            this.taskServiceQueryForm.pageSize = pageSize;
            this.queryTaskServiceList(1000);
        },
        onTaskServiceQueryCurrentPageChange(currentPage) {
            this.taskServiceQueryForm.currentPage = currentPage;
            this.doQueryTaskServiceList(1000);
        }
    },
    watch: {
        taskId: {
            handler: function(newVal, oldVal) {
                if (newVal) {
                    this.taskServiceQueryForm.taskId = newVal;
                    this.queryTaskServiceList(1000);
                }
            },
            immediate: true
        }
    }
};
</script>
<style lang="scss">
.idcard {
    color: $--color-gray;
}
.task-service-details {
    list-style-position: inside;
    padding: 5px 15px 5px 5px;
    .name {
        color: $--color-primary;
    }
}
</style>